import { NewTab } from "@/components/Icon"
import React, { FC } from "react"
import Box from "@/components/Box"
import Block from "@/components/Block"
import Container from "@/components/Container"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import { useTranslation } from "react-i18next"
import Button from "@/components/Button"
import SimpleFadeTextAnimation from "@/components/SimpleFadeTextAnimation"
import RevealTextAnimation from "@/components/RevealTextAnimation"
import Link from "@/components/Link"

const CommunitySection: FC = () => {
  const { t } = useTranslation("security")
  const certList = [
    {
      title: "aicpaSoc",
      width: ["auto", "auto", 68],
      height: [48, 50, "auto"],
    },
    {
      title: "kudelskiSecurity",
      width: ["auto", "auto", 148],
      height: [48, 50, "auto"],
    },
    {
      title: "isoIec27701",
      width: ["auto", "auto", 74],
      height: [48, 50, "auto"],
    },
    {
      title: "isoIec27001",
      width: ["auto", "auto", 74],
      height: [48, 50, "auto"],
    },
    { title: "pciDss", width: ["auto", "auto", 136], height: [48, 50, "auto"] },
  ]

  const certImageSrcArr: { [key: string]: string } = {
    aicpaSoc: `${process.env.ASSETS_BASE_URL}/security-page/community-section/aicpa-soc.webp`,
    kudelskiSecurity: `${process.env.ASSETS_BASE_URL}/security-page/community-section/kudelski-security.webp`,
    isoIec27701: `${process.env.ASSETS_BASE_URL}/security-page/community-section/iso-iec-27701.webp`,
    isoIec27001: `${process.env.ASSETS_BASE_URL}/security-page/community-section/iso-iec-22301.webp`,
    pciDss: `${process.env.ASSETS_BASE_URL}/security-page/community-section/pci-dss.webp`,
  }

  return (
    <Block bg="backgroundSecurityGrey">
      <Container>
        <SimpleFadeTextAnimation>
          <Box width={["100%", 417, 804]}>
            <Typography variant="h4" color="primaryBrightBlue" mb={[2, 1, 2]}>
              {t("section_four.eyebrow")}
            </Typography>
          </Box>
        </SimpleFadeTextAnimation>

        <Box width={["100%", 482, 898]}>
          <Typography variant="h2" mb={[12, 8, 16]}>
            <RevealTextAnimation
              text={t("section_four.h2_new") as string}
            ></RevealTextAnimation>
          </Typography>
        </Box>

        <Typography variant="h3" mb={[2, 2, 3]}>
          <RevealTextAnimation
            text={t("section_four.contents_0_title") as string}
          ></RevealTextAnimation>
        </Typography>
        <SimpleFadeTextAnimation>
          <Box width={["100%", 417, 804]} mb={[4, 2, 3]}>
            <Typography variant="bodyCopy" color="secondaryLightGrey">
              {t("section_four.contents_0_paragraph")}
            </Typography>
          </Box>
        </SimpleFadeTextAnimation>

        <Box
          customCss={{ gap: ["10px", "12px", "33.5px"] }}
          mb={[2, 8, 16]}
          flexWrap={["wrap", "wrap", "nowrap"]}
          maxWidth={["330px", "329px", "100%"]}
          display={["none", "none", "flex"]}
        >
          {certList.map(cert => (
            <Box
              as="img"
              src={certImageSrcArr[cert.title]}
              key={cert.title}
              width={cert.width}
              height={cert.height}
              loading="lazy"
            ></Box>
          ))}
        </Box>
        <Flex
          customCss={{ gap: ["3px", "10px", "33.5px"] }}
          mb={[2, 8, 16]}
          flexWrap={["wrap", "wrap", "nowrap"]}
          maxWidth={["330px", "329px", "100%"]}
          display={["flex", "flex", "none"]}
        >
          {certList.map(cert => (
            <Flex
              width={[107, 103]}
              mb={2}
              height={["48px", "50px"]}
              key={cert.title}
              alignItems="center"
              justifyContent={"center"}
            >
              <Box
                as="img"
                src={certImageSrcArr[cert.title]}
                alt={`${cert.title}`}
                width={cert.width}
                height={cert.height}
                loading="lazy"
              ></Box>
            </Flex>
          ))}
        </Flex>

        <Flex
          flexDirection={["column", "row"]}
          alignItems={["center", "flex-start"]}
          justifyContent={"space-between"}
        >
          <Box>
            <Typography variant="h3" mb={[2, 2, 3]}>
              <RevealTextAnimation
                text={t("section_four.contents_1_title") as string}
              ></RevealTextAnimation>
            </Typography>
            <SimpleFadeTextAnimation>
              <Box width={["100%", 417, 804]}>
                <Typography
                  variant="bodyCopy"
                  color="secondaryLightGrey"
                  mb={[11, 10, 11]}
                >
                  {t("section_four.contents_1_paragraph")}
                </Typography>
              </Box>
            </SimpleFadeTextAnimation>

            <SimpleFadeTextAnimation>
              <Link href="https://hackerone.com/crypto?type=team">
                <Button variant="secondaryDark" mb={[9, 0, 0]}>
                  <Typography
                    variant="primaryCta"
                    maxWidth={["250px", "max-content"]}
                    whiteSpace="pre-wrap"
                  >
                    {t("section_four.button")}
                  </Typography>
                  <NewTab ml={[2]} />
                </Button>
              </Link>
            </SimpleFadeTextAnimation>
          </Box>

          <SimpleFadeTextAnimation>
            <Box width={[62, 85, 104]}>
              <img
                src={`${process.env.ASSETS_BASE_URL}/security-page/community-section/one.webp`}
                alt="One Icon"
                width="100%"
                loading="lazy"
              />
            </Box>
          </SimpleFadeTextAnimation>
        </Flex>
      </Container>
    </Block>
  )
}

export default CommunitySection
